import {ContactUsContent} from "../../legal/ContactUsPage";
import {PrivacyPolicyContent} from "../../legal/PrivacyPolicyPage";
import {UserAgreementContent} from "../../legal/UserAgreementPage";
import {mobileImage} from "../mobileAssets";

export default function MobileLegalScreen({type}) {
    const title = type === "privacy-policy" ? "月迁网络游戏个人信息保护政策" : type === "contact-us" ? "联系我们" : "月迁网络游戏平台服务协议";
    const content = type === "privacy-policy" ? <PrivacyPolicyContent/> : type === "contact-us" ? <ContactUsContent/> : <UserAgreementContent/>;
    return (
        <div className="page_article mobile-legal-article">
            <div className="title"><span>协议</span><p>{title}</p></div>
            <div className="article">{content}</div>
            <div className="back"><button type="button" onClick={() => { window.location.hash = ""; }}><img src={mobileImage("ones_10.png")} alt="返回首页"/></button></div>
        </div>
    );
}
